import {getDefaultState} from '@/store/modules/bs_app/state'

export const SET_DEMO = 'SET_DEMO'
export const RESET_STATE = 'RESET_STATE'
export const SET_BS_APP_02_008 = 'SET_BS_APP_02_008'
export const SET_UPDATE_INFO_DETAIL = 'SET_UPDATE_INFO_DETAIL'
export const SET_DATA_BS_APP_02_001 = 'SET_DATA_BS_APP_02_001'
export const SET_DATA_BS_APP_02_002 = 'SET_DATA_BS_APP_02_002'
export const SET_DATA_BS_APP_02_005 = 'SET_DATA_BS_APP_02_005'
export const SET_DATA_BS_APP_02_004 = 'SET_DATA_BS_APP_02_004'
export const SET_DATA_LOW_PRICE = 'SET_DATA_LOW_PRICE'
export const SET_AGREE_TERM_LOW_PRICE = 'SET_AGREE_TERM_LOW_PRICE'
export const SET_SELECTED_WEB_RADIO = 'SET_SELECTED_WEB_RADIO'
export const SET_SAVE_RELATIONSHIP = 'SET_SAVE_RELATIONSHIP'
export const SET_PUBLIC_STAY = 'SET_PUBLIC_STAY'
export const SET_INFO_USER = 'SET_INFO_USER'


export default {
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState())
  },
  [SET_DEMO](state, demo) {
    state.demo = demo
  },
  [SET_BS_APP_02_008](state, payload) {
    state.bs_app.bs_app_02_008 = payload
  },
  [SET_UPDATE_INFO_DETAIL](state, payload) {
    state.bs_app.info_detail = payload
  },
  [SET_DATA_BS_APP_02_001](state, payload) {
    state.bs_app.bs_app_02_001 = payload
  },
  [SET_DATA_BS_APP_02_002](state, payload) {
    state.bs_app.bs_app_02_002 = payload
  },
  [SET_DATA_BS_APP_02_005](state, payload) {
    state.bs_app.bs_app_02_005 = payload
  },
  [SET_DATA_BS_APP_02_004](state, payload) {
    state.bs_app.bs_app_02_004 = payload
  },
  [SET_DATA_LOW_PRICE](state, payload) {
    state.bs_app.bs_app_03_001 = payload
  },
  [SET_AGREE_TERM_LOW_PRICE](state, payload) {
    state.bs_app.bs_app_03_002 = payload
  },
  [SET_SELECTED_WEB_RADIO](state, payload) {
    state.bs_app.selected_web_radio = payload
  },
  [SET_SAVE_RELATIONSHIP](state, payload) {
    state.bs_app.check_relationship = payload
  },
  [SET_PUBLIC_STAY](state, payload) {
    state.bs_app.public_stay = payload
  },
  [SET_INFO_USER](state, payload) {
    state.bs_app.info_user = payload
  }
}